/**
 * A function that adds a style-tag to the head to do global css overrides
 * @param {string} styleString ValidCSS only please
 */
export default function appendStyling(styleString = 'body { transform: skew(20deg); }') {
	const styleTag = document.createElement('style')
	styleTag.textContent = styleString
	document.head.append(styleTag)
}
